import React, { memo } from "react";
import { Image } from "@chakra-ui/react";

export const BlocksLogoForCustomerPostScoreForm: React.FC = memo(() => {
  return (
    <Image w='200px' borderRadius='10px' src="/images/logo.png" />
  );
});